// import SubDistrictsApiV2 from 'api/v2/admins/sub-districts-api-v2'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import StringUtil from 'utils/string-util'
import InputField from 'components/molecules/input-field'

const propTypes = {
  name             : PropTypes.string,
  label            : PropTypes.string,
  required         : PropTypes.bool,
  valueType        : PropTypes.string,
  formikBag        : PropTypes.object.isRequired,
  provinceKey      : PropTypes.string,
  cityKey          : PropTypes.string,
  districtKey      : PropTypes.string,
  postalCodeKey    : PropTypes.string,
  onChangeCallback : PropTypes.func
}

const defaultProps = {
  name             : 'sub_district',
  label            : 'Sub District',
  required         : false,
  valueType        : 'id',
  provinceKey      : 'province',
  cityKey          : 'city',
  districtKey      : 'district',
  postalCodeKey    : 'postal_code',
  onChangeCallback : () => {}
}

// handle nested key e.g 'address.tl_province_id'
const getValue = (values, key) => {
  const keys    = key.split('.')
  let newValues = values
  keys.map((k) => newValues = newValues[k])

  return newValues
}

/**
 * Search field to select province by name and return value is name
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {string} valueType - what the form will return value
 * @param {string} provinceKey - field name/key for province
 * @param {string} cityKey - field name/key for province
 * @param {string} districtKey - field name/key for district
 * @param {string} postalCodeKey - field name/key for postal_code
 * @param {object} formikBag
 * @param {function} onChangeCallback - to run additional logic
 */
const SubDistrictSelectField = ({
  name,
  label,
  required,
  valueType,
  provinceKey,
  cityKey,
  districtKey,
  postalCodeKey,
  formikBag,
  onChangeCallback,
  ...props
}) => {
  const [ subDistricts, setDistricts ] = useState([])
  const [ isLoading, setIsLoading ]    = useState(false)
  const provinceValue                  = getValue(formikBag.values, provinceKey)
  const cityValue                      = getValue(formikBag.values, cityKey)
  const districtValue                  = getValue(formikBag.values, districtKey)

  useEffect(() => {
    const filter = {
      [`province_${valueType}`] : provinceValue,
      [`city_${valueType}`]     : cityValue,
      [`district_${valueType}`] : districtValue
    }

    if (provinceValue === '' || cityValue === '' || districtValue === '') return

    setIsLoading(true)
    // SubDistrictsApiV2.get(filter)
    //   .then((response) => {
    //     setDistricts(response.data.tl_sub_districts)
    //     setIsLoading(false)
    //   })
    //   .catch(() => {
    //     alert('Failed to fetch Cities')
    //   })
  }, [ provinceValue, cityValue, districtValue, valueType ])

  // eslint-disable-next-line react/prop-types
  const SelectFieldOptions = ({ options, label }) => (
    <>
      <option value='' label={ `Choose ${label}` }/>
      {
        // eslint-disable-next-line react/prop-types
        options.map((option) => (
          <option
            key={ `select-option-city-${option.id}` }
            value={ isStringValue(option[valueType]) ? StringUtil.humanizeUpperCase(option[valueType]) : option[valueType] }
            label={ StringUtil.humanizeUpperCase(option.name) }
          />
        ))
      }
    </>
  )

  const isStringValue = (value) => typeof value === 'string' || value instanceof String

  return (
    <InputField
      type='select'
      label={ label }
      name={ name }
      required={ required }
      disabled={ isLoading }
      onChange={ (event) => {
        formikBag.handleChange(event)
        const inputValue = isStringValue(event.target.value) ? event.target.value.toLowerCase() : event.target.value
        // eslint-disable-next-line
        const selectedSubDistrict = subDistricts.find((value) => value[valueType] == inputValue)
        if (selectedSubDistrict) formikBag.setFieldValue(postalCodeKey, selectedSubDistrict.postal_code.toString())
        onChangeCallback(event)
      } }
      { ...props }
    >
      {
        isLoading ?
          <option
            key=''
            value=''
            label='Loading...'
          /> :
          <SelectFieldOptions
            options={ subDistricts }
            label={ label }
          />
      }
    </InputField>
  )
}

SubDistrictSelectField.propTypes    = propTypes
SubDistrictSelectField.defaultProps = defaultProps

export default SubDistrictSelectField
